import React from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { EditCaseModal } from './modals/EditCaseModal';

export function NewCaseForm({ onClose, onCaseCreated }) {
  const navigate = useNavigate();
  const [newCaseId, setNewCaseId] = React.useState<string | null>(null);

  const handleCreateCase = async () => {
    try {
      const { data, error } = await supabase
        .from('cases')
        .insert([{ status: 'new_matter' }])
        .select()
        .single();

      if (error) throw error;
      
      setNewCaseId(data.id);
      onCaseCreated(data);
    } catch (error) {
      console.error('Error creating case:', error);
      onClose();
    }
  };

  // Create case immediately when component mounts
  React.useEffect(() => {
    handleCreateCase();
  }, []);

  if (!newCaseId) return null;

  return (
    <EditCaseModal
      caseId={newCaseId}
      onClose={() => {
        onClose();
        navigate(`/cases/${newCaseId}`);
      }}
      onCaseUpdated={() => {
        onClose();
        navigate(`/cases/${newCaseId}`);
      }}
    />
  );
}